<app-doc-viewer
  title="Measure"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/measure">
    <igo-map-browser [map]="map" [view]="view">
      <div class="map-actions --vertical --bottom --right">
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>

    <igo-measurer [store]="$any(store)" [map]="map" />
  </app-example-viewer>
</app-doc-viewer>
